import {
  GET_IMAGE_PRODUCT,
  FIND_BY_ID,
  DELETE_IMAGE_PRODUCT,
  GET_IMAGE_BANNER,
  POST_IMAGE_BANNER,
  PUT_IMAGE_BANNER,
  DELETE_IMAGE_BANNER
} from '../type'

const initialState = {
  listImageProduct: null,
  imageById: null,
  countImage: 0,
  listBanner: null
}

const image = ( state = initialState, action ) => {
  switch(action.type) {
    case GET_IMAGE_PRODUCT : 
      return {
        ...state,
        listImageProduct: action.data.data,
        countImage: action.data.count
      }
    case FIND_BY_ID: {
      return {
        ...state,
        imageById: action.data.data
      }
    }
    case DELETE_IMAGE_PRODUCT:
      return {
        ...state,
     //    listImageProduct: state.listImageProduct.filter(
     //     (item) => item._id !== action.data.data.id, 
     //   )
      }
    case GET_IMAGE_BANNER:
      return {
        ...state,
        listBanner: action.data
      }
    case PUT_IMAGE_BANNER:
      return {
        ...state
      }
    case DELETE_IMAGE_BANNER:
      return {
        ...state
      }
    default:
      return state
  }
}

export default image
